// src/pages/MentionsLegales.js
import React from "react";
import "../index.css";
import useSEO from "../seo/useSEO";

export default function MentionsLegales() {
  useSEO({
    title: "Mentions légales — HLBK",
    description:
      "Mentions légales du site HLBK (hlbk.fr) — éditeur, hébergement, propriété intellectuelle, données personnelles et cookies.",
    canonical: "/mentions-legales",
    image: "/images/og-default.jpg",
  });

  return (
    <section className="legal-page">
      <header className="legal-hero">
        <h1>Mentions légales</h1>
        <p>Informations légales relatives au site hlbk.fr</p>
      </header>

      <div className="legal-card">
        <h2>Éditeur du site</h2>
        <p>
          <strong>HLBK – Photographe</strong>
          <br />
          Entreprise individuelle : <strong>Maxime HUYLEBROECK EI</strong>
          <br />
          Siège social : <strong>23 allée René Peters, 54510 Tomblaine, France</strong>
          <br />
          SIRET : <strong>799 493 952 00037</strong>
          <br />
          TVA intracommunautaire : <strong>FR19799493952</strong>
        </p>

        <p className="legal-links">
          <a href="mailto:contact@hlbk.fr">contact@hlbk.fr</a>
          <span aria-hidden="true"> · </span>
          <a href="tel:+33663252202">+33 6 63 25 22 02</a>
        </p>
      </div>

      <div className="legal-grid">
        <article className="legal-card">
          <h2>Directeur de la publication</h2>
          <p>Maxime HUYLEBROECK</p>
        </article>

       <article className="legal-card">
  <h2>Hébergement</h2>
  <p>
    Le site <strong>hlbk.fr</strong> est hébergé par :
  </p>
  <p>
    <strong>OVH SAS</strong><br />
    2 rue Kellermann<br />
    59100 Roubaix – France<br />
    Téléphone : +33 (0)9 72 10 10 07<br />
    Site web : <a href="https://www.ovh.com" target="_blank" rel="noreferrer">www.ovh.com</a>
  </p>
</article>

        <article className="legal-card">
          <h2>Propriété intellectuelle</h2>
          <p>
            L’ensemble du site (textes, photographies, images, logos, graphismes, vidéos,
            structure) est la propriété exclusive de <strong>HLBK – Maxime HUYLEBROECK</strong>,
            sauf mention contraire.
          </p>
          <p>
            Toute reproduction, représentation, modification, diffusion ou exploitation,
            totale ou partielle, sans autorisation écrite préalable est interdite.
          </p>
        </article>

        <article className="legal-card">
          <h2>Photographies et droits d’auteur</h2>
          <p>
            Les photographies présentées sur le site sont protégées par le droit d’auteur.
            Toute utilisation, reproduction ou diffusion, même partielle, est interdite
            sans autorisation écrite préalable.
          </p>
          <p>
            Crédit obligatoire en cas d’autorisation : <strong>© HLBK – www.hlbk.fr</strong>
          </p>
        </article>

        <article className="legal-card">
          <h2>Données personnelles</h2>
          <p>
            Les informations collectées via le formulaire de contact sont destinées
            exclusivement à HLBK pour le traitement des demandes et la relation commerciale.
          </p>
          <p>
            Conformément au RGPD, vous disposez d’un droit d’accès, de rectification et de
            suppression. Pour l’exercer :{" "}
            <a href="mailto:contact@hlbk.fr">contact@hlbk.fr</a>.
          </p>
          <p>Aucune donnée personnelle n’est cédée ou vendue à des tiers.</p>
        </article>

        <article className="legal-card">
          <h2>Cookies</h2>
          <p>
            Le site peut utiliser des cookies à des fins de mesure d’audience, de fonctionnement
            et d’amélioration de l’expérience utilisateur.
          </p>
          <p>
            Vous pouvez configurer votre navigateur pour refuser ou limiter l’utilisation des cookies.
          </p>
        </article>

        <article className="legal-card">
          <h2>Responsabilité</h2>
          <p>
            HLBK s’efforce de fournir des informations aussi précises que possible. Toutefois,
            HLBK ne pourra être tenu responsable des omissions, inexactitudes ou carences dans la mise à jour.
          </p>
        </article>

        <article className="legal-card">
          <h2>Droit applicable</h2>
          <p>
            Les présentes mentions légales sont soumises au droit français. En cas de litige,
            les tribunaux compétents seront ceux du ressort du domicile du Prestataire, sauf
            disposition légale impérative contraire.
          </p>
          <p className="legal-note">Mentions légales mises à jour : janvier 2026</p>
        </article>
      </div>
    </section>
  );
}